import {
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay, useMediaQuery, VStack
} from "@chakra-ui/react";
import {CustomSelectCountries, InputLabel, StyledButton} from "../../index";
import {ReactComponent as MessageIcon} from "../../../assets/icons/profile/envelope.svg";
import {useForm} from "react-hook-form";
import React, {useEffect, useState} from "react";
import {ReactComponent as TelegramIcon} from "../../../assets/icons/telegramIcon.svg";


export const EditUserModal = ({isOpen, onClose, user}) => {
    const [isMobile] = useMediaQuery("(max-width: 1270px)");
    const [selectedCountry, setSelectedCountry] = useState('');

    const {
        register,
        handleSubmit,
        reset,
        formState: {errors, isValid}
    } = useForm({
        mode: "onTouched",
        defaultValues: {
            email: '',
            phone: '',
            telegramNic: '',
        }
    })

    useEffect(() => {
        if (!user) return
        reset(user)
        setSelectedCountry(user.country)
    },[user])

    const submit = () => {

    }

    return (
        <Modal
            isCentered
            isOpen={isOpen}
            onClose={onClose}>
            <ModalOverlay/>
            <ModalContent
                borderRadius={'8px'}
                bg={'neutral.1100'}>
                <ModalHeader
                    color={'neutral.100'}
                    fontSize={'heading.xl'}>
                    Edit information
                </ModalHeader>
                <ModalCloseButton color={'neutral.500'}/>
                <ModalBody py={'32px'}>
                    <form onSubmit={handleSubmit(submit)}>
                        <VStack
                            gap={'24px'}
                            w={'full'}>
                            <InputLabel
                                bg={'neutral.900'}
                                label={'Email'}
                                height={isMobile ? '40px' : '52px'}
                                isInvalid={!!errors.email}
                                errormessage={!!errors.email && errors.email.message}
                                {...register('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                        message: "Invalid email address",
                                    },
                                })}
                                placeholder={'Email or Phone number'}
                                leftAddon={<MessageIcon width={isMobile ? '20px' : '26px'}/>}/>
                            <HStack w={'full'}>
                                <CustomSelectCountries
                                    bg={'#23262F'}
                                    isMobile={isMobile}
                                    selectedCountry={selectedCountry}
                                    setSelectedCountry={setSelectedCountry}/>
                                <InputLabel
                                    bg={'neutral.900'}
                                    label={'Phone'}
                                    height={isMobile ? '40px' : '52px'}
                                    type={'number'}
                                    isInvalid={!!errors.phone}
                                    errormessage={!!errors.phone && errors.phone.message}
                                    {...register('phone', {
                                        required: 'Phone is required',
                                    })}
                                    />
                            </HStack>
                            <InputLabel
                                bg={'neutral.900'}
                                label={'Telegram'}
                                height={isMobile ? '40px' : '52px'}
                                isInvalid={!!errors.telegramNic}
                                errormessage={!!errors.telegramNic && errors.telegramNic.message}
                                {...register('telegramNic', {
                                    required: 'Telegram is required',
                                })}
                                placeholder={'Telegram Nickname'}
                                leftAddon={<TelegramIcon width={isMobile ? '20px' : '26px'}/>}/>
                            <StyledButton
                                disabled={!(isValid)}
                                type={'submit'}
                                height={isMobile ? '40px' : '52px'}
                                fontSize={'body.lg'}
                                h={'56px'}
                                w={'full'}>
                                Save
                            </StyledButton>
                        </VStack>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}